import { useLocation } from "react-router-dom"
import { normalizePathname } from "@utils/helpers"
import { ROUTES } from "@constants"
import { RouteTreeNode } from "@/types"

type BreadcrumbItem = {
  breadcrumbName?: string
  path: string
  isShowBreadcrumbHeader?: boolean
}

export function useBreadcrumb(): BreadcrumbItem[] {
  const pathname = useLocation().pathname

  function findBreadcrumbsByPath(routes: RouteTreeNode, targetPath: string): BreadcrumbItem[] {
    const stack: Array<{ node: RouteTreeNode; path: BreadcrumbItem[] }> = [{ node: routes, path: [] }]

    while (stack.length > 0) {
      const { node, path } = stack.pop()!

      if (normalizePathname(node.path) === normalizePathname(targetPath)) {
        return path.concat({
          breadcrumbName: node.breadcrumbName,
          path: "",
          isShowBreadcrumbHeader: node.isShowBreadcrumbHeader,
        })
      }

      if (node.children) {
        for (const child of node.children) {
          stack.push({
            node: child,
            path: path.concat({
              breadcrumbName: node.breadcrumbName,
              path: node.path,
              isShowBreadcrumbHeader: node.isShowBreadcrumbHeader,
            }),
          })
        }
      }
    }

    return []
  }

  return findBreadcrumbsByPath(ROUTES, pathname)
}
